module.exports = __webpack_public_path__ + "img/list-left.731e0d7f.png";